import {Skeleton} from "@mui/material";
import React from "react";

export const TxtSuspense = ({w = 80, h = 20}: { w?: number, h?: number }) =>
    <Skeleton variant="text" width={w} height={h}/>;

export const InputSuspense = ({h = 32}: { h?: string | number }) =>
    <Skeleton variant="rectangular" width="100%" height={32}/>;
export const LabelSuspense = () => <Skeleton variant="text" width={70} height={20}/>;
